'use client';

import {
  desktopSidebar,
} from '../../../../jotaiStore';
import { useAtom } from 'jotai';
import { CareerMap, SubTopic } from '../../../../types';
import BottomNavigation from '../../../../features/nav/BottomNav';
import MarkDownContainer from './MarkDownContainer';
import { useState } from 'react';

const MainPanel = () => {
  const [showDesktopSidebar, setShowDesktopSidebar] = useAtom(desktopSidebar);
  const [isNavLoading, setIsNavLoading] = useState(false);
  return (
    <>
      <MarkDownContainer isNavLoading={isNavLoading} setIsLoading={setIsNavLoading} />
      <BottomNavigation showDesktopSidebar={showDesktopSidebar} setIsNavLoading={setIsNavLoading} />
    </>
  );
};

export default MainPanel;
